import { User } from './models';

export interface LoginState {
  user: User | null;
  loading: boolean;
  pagesLoading: boolean;
  azureAdAuthorized: boolean;
  isPublic: boolean;
}

export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_PAGES_LOADING = 'LOGIN_PAGES_LOADING';
export const LOGIN_AZURE_AD_AUTHORIZED = 'LOGIN_AZURE_AD_AUTHORIZED';
export const LOGIN_IS_PUBLIC = 'LOGIN_IS_PUBLIC';

interface LoginLoadingAction {
  type: typeof LOGIN_LOADING;
  payload: boolean;
}

interface LoginPagesLoadingAction {
  type: typeof LOGIN_PAGES_LOADING;
  payload: boolean;
}

interface LoginAzureAdAuthorizedAction {
  type: typeof LOGIN_AZURE_AD_AUTHORIZED;
  payload: boolean;
}

interface LoginIsPublicAction {
  type: typeof LOGIN_IS_PUBLIC;
  payload: boolean;
}

export type LoginActionTypes =
  | LoginLoadingAction
  | LoginPagesLoadingAction
  | LoginAzureAdAuthorizedAction
  | LoginIsPublicAction;
